import { ApiService } from '@services/api/api.service';

import { DOCUMENT } from '@angular/common';
import { inject, Inject, Injectable } from '@angular/core';
import { IBasicInfo, IFundraiser } from '@models/fundraiser.model';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { IUTM } from '@models/utm.model';
import { CookieService } from '@services/cookie/cookie.service';
import { VariablesService } from '@services/variables/variables.service';
import { EventsService } from '@services/events/events.service';
import { IUser } from '@models/user.model';
import { ActivatedRoute } from '@angular/router';
import { FacebookService } from 'ngx-facebook';

@Injectable({
  providedIn: 'root'
})
export class ShareMessagesService {
  private document = inject(DOCUMENT);
  public storageService = inject(StorageService);
  private util = inject(UtilService);
  public cookieService = inject(CookieService);
  private vars = inject(VariablesService);
  public eventsService = inject(EventsService);
  private actRout = inject(ActivatedRoute);
  private apiService = inject(ApiService);
  public fb = inject(FacebookService);

  isLoggedIn;
  userdata: IUser;
  constructor() {
    this.util.isLoggedIn.subscribe({ next: res => this.isLoggedIn = res });
    this.vars.userData.subscribe({ next: res => this.userdata = res });
  }

  /**
 * Get The Whatsapp message
 * @param fundraiser Fundraiser Object
 */
  getFacebookUtm(fundraiser: IFundraiser) {
    return `?utm_source=internal&utm_medium=fbpageshare&utm_campaign=${fundraiser.custom_tag}` + this.getUtmContent();
  }

  /**
   * Get The Whatsapp message
   * @param fundraiser Fundraiser Object
   * @param basicInfo Basic Info of fundraiser
   * @param fStatus Fundraiser ENded Status
   */
  async getWhatsAppMessage(fundraiser: IFundraiser, basicInfo: IBasicInfo, fStatus: boolean, utms?, useLongUrl = false) {
    let pageName = 'fundraiser';
    if (this.vars.fundraiser.support_campaign) {
      pageName = 'supportfundraiser';
    }
    const page = this.vars.campaignType === 'stories' ? 'stories' : pageName;
    const campaignUrl = `${this.util.domain_details.domain_url}/${page}/${fundraiser.custom_tag}`;
    // const shortURL = await this.apiService.getShortURL(`rm-${fundraiser.custom_tag}`, campaignUrl);
    // console.log(shortURL);
    const host = this.util.domain_details.domain_url;
    const about_html = this.document.createElement('div');
    const utmData = {
      source: utms?.utm_source || 'internal',
      medium: utms?.utm_medium || 'whatsappShare',
      term: utms?.utm_term || 'whatsappShare',
      campaign_name: fundraiser.custom_tag
    };
    const payload = {
      id: `rm-${fundraiser.custom_tag}`,
      long_url: this.getLinkWithUtmTags(campaignUrl, utmData),
      utm_content: this.userdata?.id ? this.userdata?.id : ''
    }
    let shortOrLongURL;
    if (!useLongUrl) {
      shortOrLongURL = await this.apiService.getShortURL(payload);
    } else {
      shortOrLongURL = this.getLinkWithUtmTags(campaignUrl, utmData);
    }
    about_html.innerHTML = this.vars.basicInfo.social;
    let about_text = about_html.textContent;
    about_text = about_text.replace(/\s\s+/g, ' ');
    if (about_text.length > 441) {
      about_text = `*${this.util.capitalizeFirstLatter(fundraiser.title)}* \n\n` + about_text.substr(0, 441).concat('...');
    }
    // If fundraiser ended then no contibute link
    let campainerName = '';

    if (fundraiser.campaigner && fundraiser.campaigner.full_name) {
      campainerName = fundraiser.campaigner.full_name.trim();
    } else {
      campainerName = 'Campaigner';
    }

    // Campaing Web URL
    let web_link = `\n\n*Read More.* ${shortOrLongURL}\n\n`;

    if (!fStatus) {
      // Campaing Web URL
      web_link = `\n\n*Read More & Donate Now.* ${shortOrLongURL}\nEven a small amount will make a difference.\n\n`;
    }

    // `${host}/contribute/contribute.php${this.getLinkWithUtmTags('', utmData)}&fmd_id=${fundraiser.id}`;
    // Finally a cooked text ready for whatsapp
    const text_to_share = about_text + web_link;

    return encodeURIComponent(text_to_share);
  }
  /**Whatsapp share from sac thank you page */
  getWhatsAppMessage3(fundraiser) {
    let pageName = 'fundraiser';
    if (this.vars.fundraiser.support_campaign) {
      pageName = 'supportfundraiser';
    }
    const campaignUrl = `${this.util.domain_details.domain_url}/${pageName}/${fundraiser.custom_tag}`;
    const utmData = {
      source: 'internal',
      medium: 'whatsappShare',
      campaign_name: this.vars.fundraiser.custom_tag,
    };
    let beneficiaryRelation = '';
    if (fundraiser.beneficiaryrelation && fundraiser.beneficiaryrelation.info_1) {
      beneficiaryRelation = 'for my ' + fundraiser.beneficiaryrelation.info_1;
    }
    const text_to_share = `Hi,\n\n*I have started a fundraiser on Ketto* ${beneficiaryRelation}`
      .concat(`\n\nI am sharing it with the *people closest* to me and *you* are amongst them 😇`)
      .concat(`\n\nIt is *essential that I receive support, no matter how small it is*, to keep it going`)
      .concat(`\n\n${this.getLinkWithUtmTags(campaignUrl, utmData)}&utm_placement=sac_thank_you`)
      .concat(`\n\nThanks for your support in advance 🙏🏼`);
    return encodeURIComponent(text_to_share);
  }

  getWhatsAppMessageForDream11() {
    const campaignUrl = `${this.util.domain_details.domain_url}/fundriaser/${this.vars.fundraiser.custom_tag}`;
    const utmData = {
      source: 'internal',
      medium: 'whatsappShare',
      campaign_name: this.vars.fundraiser.custom_tag
    };
    const message = `Come join the team and help us fight against COVID. \n\n${this.getLinkWithUtmTags(campaignUrl, utmData)}`;
    this.shareEvents('whatsapp share', 36);
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
  }

  getUtmContent() {
    const data = this.util.getUser()?.user;
    const userId = this.util.getUserData()?.id;
    const _ku = this.cookieService.getCookie('_ku');
    if (data) {
      return `&utm_content=${userId}`;
    } else if (_ku) {
      return `&utm_content=${_ku}`;
    } else {
      return '';
    }
  }
  /**Get the UTMS for the link */
  getLinkWithUtmTags(link: string, data: IUTM) {
    let tags = `?utm_medium=${data.medium}${this.getUtmContent()}&shby=1&utm_term=${data?.term || ''}`;
    const prviousUtms = this.util.getUTMs();
    tags = tags.concat(prviousUtms.hasOwnProperty('utm_source') ? `&utm_source=${prviousUtms.utm_source}` : `&utm_source=${data.source}`);
    if (data.campaign_name) {
      tags = tags.concat(`&utm_campaign=${data.campaign_name}`);
    }
    if (this.actRout.snapshot.queryParams['update_id']) {
      tags = tags.concat(`&update_id=${this.actRout.snapshot.queryParams['update_id']}`);
    }
    return link ? link + tags : tags;
  }

  /**Event fired after share */
  shareEvents(eventName, postion) {
    const systemEvent = {
      eventName: eventName,
      event_type: 'campaign',
      event_type_id: this.vars?.fundraiser?.id,
      info_1: 'position',
      info_2: postion || 3,
      info_3: this.vars.campaignType,
      page_name: this.vars.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
    const claverTap = {
      'Campaign Id': this.vars.fundraiser.id,
      'Page URL': this.util.domain_details.full_url,
      'Campaign Title': this.vars.fundraiser.title,
      'Browser': this.util.detectBrowser(),
      'Campaign Type': this.util.getCampaignTypeFromId(this.vars.fundraiser.id),
      'Cause ID': this.vars.fundraiser.cause_id,
      'Device Type': this.util.isMobile() ? 'Mobile' : 'Desktop'
    };
    this.eventsService.claverTapPush(eventName, claverTap);
    const gtmData = {
      'event': 'social_shares',
      'event_category': eventName,
      'event_action': `social share ${eventName}`,
      'event_label': this.getEntity(), // campaigner or visitor or ngo
      'Campaign_custom_tag': this.vars.fundraiser.custom_tag || '',
      'Campaign_cause_id': this.vars.fundraiser.cause_id || '',
      'Campaign_Type': this.util.getCampaignTypeFromId(this.vars.fundraiser.id) || '',
      'Page_version': '',
      'position': postion || 3
    };
    this.eventsService.gtmPush(gtmData);
  }
  getEntity() {
    if (this.isLoggedIn) {
      this.util.getUserType(
        this.vars.fundraiser.creator_entity_details_id,
        this.vars.fundraiser.entity_details_id,
        this.userdata?.id
      );
    }
  }

  getShareUrl(data: any, fundraiser: IFundraiser) {
    if (this.util.isBrowser && fundraiser) {
      const utmData: IUTM = {
        source: 'internal',
        medium: data?.medium,
        campaign_name: fundraiser.custom_tag,
        term: data?.term || ''
      };
      const page = this.vars.pageName === 'stories' ? 'stories' : 'fundraiser';
      const link = `${this.util.domain_details.domain_url}/${page}/${fundraiser.custom_tag}`;
      return this.getLinkWithUtmTags(link, utmData);
    } else {
      return '';
    }
  }

  async instagramShare(data: any, fundraiser: IFundraiser) {
    const sharableLink = this.getShareUrl({ medium: data?.medium, term: this.vars.pageName }, fundraiser);
    const copied = await this.util.copyToClipboard(sharableLink);
    if (!copied) return;
    this.util.openSnackBar(`Link copied! Paste it in your DM or Story.`, 'success', { duration: 6000, verticalPosition: 'bottom' });
    const appUrl = 'instagram://direct';
    const webUrl = 'https://www.instagram.com/direct/inbox/';
    setTimeout(() => {
      if (!this.util.isMobile()) {
        window.open(webUrl, '_blank');
        return;
      }
      let appOpened = false;
      const visibilityHandler = () => {
        if (document.hidden) appOpened = true;
      };
      document.addEventListener('visibilitychange', visibilityHandler);
      window.location.href = appUrl;
      setTimeout(() => {
        document.removeEventListener('visibilitychange', visibilityHandler);
        if (!appOpened) window.open(webUrl, '_blank');
      }, 1200);
    }, 2000);
  }
}
